import React, { useEffect, useState } from 'react'
import Table from '../Table/Table'
import config from '../../config';

function PaymentsMade() {
    const [data, setData] = useState([]);

    const columns = ['#', 'Date', 'Amount', 'Payment Type'];

    useEffect(() => {
        fetchPayments();
    });

    const fetchPayments = async () => {
        try {
            const response = await fetch(`${config.BASE_URL}/supplierPayments`);
            if (!response.ok) {
                throw new Error('Failed to fetch Payments list');
            }
            const payments = await response.json();
            const formattedData = payments.map(payment => {
                const payDate = new Date(payment.payDate);
                const formattedPayDate = `${payDate.getFullYear()}-${String(payDate.getMonth() + 1).padStart(2, '0')}-${String(payDate.getDate()).padStart(2, '0')} ${String(payDate.getHours()).padStart(2, '0')}:${String(payDate.getMinutes()).padStart(2, '0')}`;

                const paymentType = payment.paymentType.toLowerCase();
                let paymentTypeDisplay;
                if (paymentType === 'cash') {
                    paymentTypeDisplay = <span style={{ color: 'green' }}>Cash</span>;
                } else if (paymentType === 'cheque') {
                    paymentTypeDisplay = <span style={{ color: '#FFD700' }}>Cheque</span>; 
                } else {
                    paymentTypeDisplay = payment.paymentType; 
                }

                return [
                    payment.payId,
                    formattedPayDate,
                    payment.payAmount,
                    paymentTypeDisplay, 
                ];
            });
            setData(formattedData);
        } catch (err) {
            console.log(err.message);
        }
    };

    const title = 'Payments';
    const invoice = 'Payments.pdf';

    return (
        <div>
            <div className="scrolling-container">
                <h4>Payment</h4>
                <Table
                    data={data}
                    columns={columns}
                    showActions={false}
                    showButton={false}
                    showDate={false}
                    title={title}
                    invoice={invoice}
                />
            </div>
        </div>
    )
}

export default PaymentsMade